import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUnsavedChanges } from "../components/editor/UnsavedChangesContext";
import authService from "../services/authService";

function LogOut() {
  const navigate = useNavigate();
  const { setHasUnsavedChanges } = useUnsavedChanges();

  useEffect(() => {
    authService.logout();
    setHasUnsavedChanges(false);
    navigate("/");
  }, [navigate, setHasUnsavedChanges]);

  return null;
}

export default LogOut;